const tokens = {
  ngnt: {
    name: 'Golem Network Tokens',
    ticker: 'GLM'
  }
};

export {
  tokens
};
